import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	MaybePartialRoleBasedNotificationResponse,
	TransitioningStatusResponse,
} from '../../../../common/types';

const getTransitioningStatus = (cloudId: string, isAdmin: boolean) =>
	performGetRequest<TransitioningStatusResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/transitioning?isAdmin=${isAdmin}`,
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getTransitioningStatus',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});

const getNotificationPreferences = (cloudId: string) =>
	performGetRequest<MaybePartialRoleBasedNotificationResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences`,
	)
		.then((res) =>
			// TODO: return name and role if it is necessary for the UI
			({ isRBNEnabled: !!res.roleBasedNotificationName }),
		)
		.catch((err) => {
			fireErrorAnalytics({
				meta: {
					id: 'getNotificationPreferences',
					packageName: 'jiraEocChangeboarding',
					teamName: 'alexstrasza',
				},
				error: err,
				sendToPrivacyUnsafeSplunk: true,
			});
			throw err;
		});

export { getTransitioningStatus, getNotificationPreferences };
